"use client";
import styles from "./page.module.scss";
import "@/src/style/post.css";
import PostDetail from "../../../../component/detail/post-detail";
import { Breadcrumb, Pagination } from "antd";
import Link from "next/link";
import React, { useState } from "react";
import { getListPosts } from "../service";

export default function BodyListPost({ data, type, clinic_slug }) {
  const clinic = data.clinic;
  const doctor = data.doctor;
  const avatar = clinic ? clinic.image[0] : doctor.image[0];

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPosts, setDataPosts] = useState(data.data);

  const scrollTo = () => {
    let sectionLeftHeight =
      document.getElementById("BreadcrumbPost")?.offsetHeight;
    window.scrollTo({
      top: `${sectionLeftHeight}`,
      left: 0,
      behavior: "smooth",
    });
  };
  async function onChangePage(page) {
    const params = {
      page: page,
      clinic_slug: clinic.slug,
      doctor_slug: doctor.slug,
    };
    const dataPosts = await getListPosts(params);
    setDataPosts(dataPosts.data);
    setCurrentPage(page);
    scrollTo();
  }

  return (
    <>
      <div className={styles.wpDetailListPost}>
        <h1 style={{ display: "none" }}>TIN TỨC</h1>
        <div className={styles.nav} id="BreadcrumbPost">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link href="/">Trang Chủ</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                href={
                  clinic
                    ? `/phong-kham/${clinic?.slug}`
                    : type == "CLINIC"
                    ? `/phong-kham/${clinic_slug}/${doctor?.slug}`
                    : `/bac-si/${doctor?.slug}`
                }
              >
                {clinic ? clinic?.name : doctor?.name}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link href="">{clinic ? "Tin Tức" : "Hoạt động"}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.wpBodyPost}>
          {dataPosts &&
            dataPosts.map((item) => {
              return (
                <PostDetail
                  item={item}
                  clinicAvatar={avatar}
                  type={"LIST"}
                  clinicName={clinic ? clinic?.name : doctor?.name}
                />
              );
            })}
          {data?.total > 10 && (
            <div className={styles.pagination}>
              <Pagination
                current={currentPage}
                total={data?.total}
                onChange={(page) => onChangePage(page)}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
